import crypto from 'crypto-js'

const SSO = {
  WalletCampaignsAgencyConnection: {
    app_id: '66069c1c7cdc95f01fba3388',
    key: '83bd0b79-04db-4c65-91a8-2058001b9c36',
  },
}

const decryptData = (payload, appKey) => {
  console.log('Decrypting SSO Data')

  try {
    const decrypted = crypto.AES.decrypt(payload, appKey).toString(
      crypto.enc.Utf8
    )

    if (decrypted !== '') {
      console.log('SSO', decrypted)
      return decrypted
    }

    return ''
  } catch (error) {
    console.error('Error decrypting data:', error)
    return ''
  }
}

const checkSSO = () => {
  console.log('Checking for SSO')
  return new Promise((resolve, reject) => {
    if (
      process.env.REACT_APP_ENV === 'staging' ||
      process.env.REACT_APP_ENV === 'production'
    ) {
      const handleMessage = ({ data }) => {
        if (data.message === 'REQUEST_USER_DATA_RESPONSE') {
          const sso = {
            app_id: SSO.WalletCampaignsAgencyConnection.app_id,
            key: SSO.WalletCampaignsAgencyConnection.key, // Use the key from SSO config
          }
          const decrypted = decryptData(data.payload, sso.key)
          if (decrypted) resolve(decrypted)
          else {
            // ADD REMOVE SSO HERE IF NEEDED
            reject('No SSO Data Found')
          }
        }
      }
      window.parent.postMessage({ message: 'REQUEST_USER_DATA' }, '*')
      window.addEventListener('message', handleMessage, { once: true })
    } else {
      resolve(
        JSON.stringify({
          // Fasih
          userId: 'tyOmSN8yQoxUAwAUREsU',
          companyId: '9qSSbwBUUtELWaEwyE5C',
          role: 'admin',
          type: 'agency',
          userName: 'Muhammad Fasih',
          email: 'fasih@levelupmarketplace.com',
          // activeLocation: 'oSyDvzImlFQlUka8cbhJ',

          // userId: 'x1JtQqk9aBYR874kx3mA',
          // companyId: '6NKdTpPe08P8DR5Jg7k6',
          // role: 'admin',
          // type: 'agency',
          // userName: 'Zia Arsalan',
          // email: 'faraz@walletcampaigns.com',
          // activeLocation: 'zcNF3GmlaQH6H095QjQR',
        })
      )
    }
  })
}

export default checkSSO
